export enum EmailEvent {
    Verified = 'Email.Verified',
    VerifiedCodePath = 'Email Verified',
}
